module.exports = __webpack_public_path__ + "assets/img/bfdda0f9e773a7ba44b33c072ce2284b.png";